function Home() {
    return <h1>Welcome to Vishnupriya Budget App</h1>;
  }
  
  export default Home;